import React from 'react';

const QuickContact = () => {
    return (
        <aside className="floating-widget" aria-label="Phím tắt liên hệ nhanh">
            {/* Call Hotline */}
            <a
                href="tel:02543886336"
                className="quick-action-btn btn-call"
                aria-label="Gọi hotline 02543 886 336"
            >
                <i className="fas fa-phone-alt"></i>
                <span className="btn-tooltip">Gọi Ngay: 02543 886 336</span>
            </a>

            {/* Google Maps Direction */}
            <a
                href="https://www.google.com/maps/place/Caf%C3%A9+9/@10.4274525,107.2911641,17z/data=!3m1!4b1!4m6!3m5!1s0x31759e1efbb326c1:0xcbb3bd737dd53a20!8m2!3d10.4274525!4d107.2911641!16s%2Fg%2F11rvh_k9m7"
                target="_blank"
                rel="noopener noreferrer"
                className="quick-action-btn btn-map"
                aria-label="Chỉ đường Google Maps"
            >
                <i className="fas fa-diamond-turn-right"></i>
                <span className="btn-tooltip">Chỉ Đường Quán</span>
            </a>

            {/* Facebook Messenger / Fanpage */}
            <a
                href="https://www.facebook.com/cafe9phuochai"
                target="_blank"
                rel="noopener noreferrer"
                className="quick-action-btn btn-fb"
                aria-label="Nhắn tin Facebook Fanpage"
            >
                <i className="fab fa-facebook-messenger"></i>
                <span className="btn-tooltip">Chat Fanpage</span>
            </a>
        </aside>
    );
};

export default QuickContact;
